import React from 'react'
import Header from './Header'
import Routes from './Routes'
// import Footer from './Footer'
import { Container} from 'semantic-ui-react'
import 'babel-polyfill'

export default () => (
    <div>
        <Header />
        <Container style={{ minHeight: '219px' }}>
            <Routes />
        </Container>
        {/* <Footer /> */}
    </div>
)


// WEBPACK FOOTER //
// ./src/features/ui/components/App.js